export const CONTACT = {
  phoneDisplay: "+91 96408 05544",
  tel: "tel:+919640805544",
  whatsapp: "https://wa.me/919640805544",
  email: "ogoandhra@gmail.com",
  hours: {
    en: "Mon – Sun · 6:00 AM – 9:00 PM",
    te: "సోమ – ఆది · ఉదయం 6:00 – రాత్రి 9:00",
  },
  area: {
    en: "Visakhapatnam & surroundings",
    te: "విశాఖపట్నం & పరిసర ప్రాంతాలు",
  },
};

export const waLink = (msg) =>
  `${CONTACT.whatsapp}?text=${encodeURIComponent(msg)}`;

export const IMG = {
  hero: "https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce?q=80&w=1200&auto=format&fit=crop",
  house: "https://images.unsplash.com/photo-1758272421751-963195322eaa?q=80&w=1600&auto=format&fit=crop",
  tank: "https://images.unsplash.com/photo-1764344815153-3a356c392561?q=80&w=900&auto=format&fit=crop",
  ac: "https://images.unsplash.com/photo-1601659404194-97d2daca8383?q=80&w=900&auto=format&fit=crop",
  pest: "https://images.unsplash.com/photo-1747659629851-a92bd71149f6?q=80&w=900&auto=format&fit=crop",
  fridge: "https://images.unsplash.com/photo-1764705637770-9fc400e090cb?q=80&w=1400&auto=format&fit=crop",
  handy: "https://images.unsplash.com/photo-1660330589827-da8ab7dd3c02?q=80&w=1600&auto=format&fit=crop",
  about: "https://images.unsplash.com/photo-1581578949510-fa7315c4c350?q=80&w=1200&auto=format&fit=crop",
};

/* Pre-filled WhatsApp text sent to OGO after a booking */
export const bookingMessage = (b) =>
  `Hi OGO! New booking ${b.id}\nService: ${b.service_name.en}\nDate: ${b.date} ${b.time}\nName: ${b.name}\nPhone: ${b.phone}\nAddress: ${b.address}\nTotal: ₹${b.total}${b.coupon_code ? ` (coupon ${b.coupon_code})` : ""}`;

/* Full-bleed section background photos (dimmed behind content) */
export const BG = {
  hero: "https://images.unsplash.com/photo-1724582586495-d050726cf354?q=80&w=2000&auto=format&fit=crop",
  about: "https://images.unsplash.com/photo-1640357897497-599b4fc84f51?q=80&w=2000&auto=format&fit=crop",
  packages: "https://images.unsplash.com/photo-1758273238847-bc2c2548e210?q=80&w=2000&auto=format&fit=crop",
  reviews: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?q=80&w=2000&auto=format&fit=crop",
  contact: "https://images.unsplash.com/photo-1580842402762-6f5868c17412?q=80&w=2000&auto=format&fit=crop",
};

export const GALLERY = [
  { src: "https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce?q=80&w=1200&auto=format&fit=crop", span: "col-span-2 row-span-2" },
  { src: "https://images.unsplash.com/photo-1758272421751-963195322eaa?q=80&w=800&auto=format&fit=crop", span: "col-span-1 row-span-1" },
  { src: "https://images.unsplash.com/photo-1601659404194-97d2daca8383?q=80&w=800&auto=format&fit=crop", span: "col-span-1 row-span-1" },
  { src: "https://images.unsplash.com/photo-1581578949510-fa7315c4c350?q=80&w=800&auto=format&fit=crop", span: "col-span-1 row-span-1" },
  { src: "https://images.unsplash.com/photo-1763026227930-ec2c91d4e7f2?q=80&w=800&auto=format&fit=crop", span: "col-span-1 row-span-1" },
  { src: "https://images.unsplash.com/photo-1764344815153-3a356c392561?q=80&w=1200&auto=format&fit=crop", span: "col-span-2 row-span-1" },
  { src: "https://images.unsplash.com/photo-1670989292166-8b20b9530438?q=80&w=800&auto=format&fit=crop", span: "col-span-1 row-span-1" },
  { src: "https://images.unsplash.com/photo-1669101602108-fa5ba89507ee?q=80&w=800&auto=format&fit=crop", span: "col-span-1 row-span-1" },
];

export const REVIEWS = [
  {
    service: { en: "Pest Control", te: "పెస్ట్ కంట్రోల్" },
    text: "OGO Hygiene Solutions pest control service చాలా బాగుంది. Team professional-ga వచ్చి సమస్యను explain చేసి treatment చేశారు. Service చాలా satisfactory-ga ఉంది.",
  },
  {
    service: { en: "Pest Control", te: "పెస్ట్ కంట్రోల్" },
    text: "ఇంట్లో termites problem కోసం OGO వాళ్లను contact చేశాను. Response చాలా fast-ga ఉంది. Team neat-ga work చేశారు. Good service.",
  },
  {
    service: { en: "House Cleaning", te: "హౌస్ క్లీనింగ్" },
    text: "House cleaning service చాలా neat-ga చేశారు. Corners, kitchen area, bathroom అన్నీ బాగా clean చేశారు. Staff behaviour కూడా చాలా మంచిగా ఉంది.",
  },
  {
    service: { en: "House Cleaning", te: "హౌస్ క్లీనింగ్" },
    text: "Time కి వచ్చి professional-ga cleaning చేశారు. ఇంటి మొత్తం చాలా clean & fresh-ga అనిపించింది. OGO Hygiene Solutions service నచ్చింది.",
  },
  {
    service: { en: "Water Tank Cleaning", te: "వాటర్ ట్యాంక్ క్లీనింగ్" },
    text: "Water tank cleaning చాలా hygienic-ga చేశారు. Tank లో ఉన్న dirt మొత్తం clean చేసి neat-ga handover చేశారు. Good service and reasonable pricing.",
  },
  {
    service: { en: "Water Tank Cleaning", te: "వాటర్ ట్యాంక్ క్లీనింగ్" },
    text: "చాలా రోజుల తర్వాత మా water tank clean చేయించుకున్నాం. OGO team చాలా carefully work చేశారు. Service quality చాలా బాగుంది.",
  },
  {
    service: { en: "Water Supply", te: "వాటర్ సప్లై" },
    text: "Emergency time లో water requirement ఉండడంతో OGO water supply service తీసుకున్నాం. Quick response ఇచ్చారు, delivery కూడా on time చేశారు. Very useful service.",
  },
  {
    service: { en: "Handyman Service", te: "హ్యాండీమ్యాన్ సర్వీస్" },
    text: "చిన్న చిన్న home repair works కోసం handyman service తీసుకున్నాం. Technician experienced-ga ఉండి work త్వరగా complete చేశారు. Very convenient.",
  },
  {
    service: { en: "Handyman Service", te: "హ్యాండీమ్యాన్ సర్వీస్" },
    text: "Electric/plumbing related work కోసం OGO technician ని book చేశాం. Technician time కి వచ్చి సమస్యను check చేసి properly solve చేశారు. Good experience.",
  },
  {
    service: { en: "OGO Hygiene Solutions – Overall", te: "OGO Hygiene Solutions – మొత్తం మీద" },
    text: "ఒకే platform లో pest control, cleaning, water tank cleaning, water supply, handyman services అందించడం చాలా useful-ga ఉంది. Response quick-ga ఉంది, staff కూడా professional-ga ఉన్నారు. Definitely recommend OGO Hygiene Solutions.",
    highlight: true,
  },
];
